import React, { useState } from 'react';
import {
    Accordion,
    AccordionDetails,
    AccordionGroup,
    AccordionSummary, Autocomplete,
    Button,
    FormControl,
    Input, Textarea,
    Typography, Link, Box
} from '@mui/joy';
import FormLabel from "@mui/joy/FormLabel";
import AddIcon from '@mui/icons-material/Add';


const PersQuizGen = () => {
    const [dataUrl, setDataUrl] = useState(null);
    const [embedHeight, setEmbedHeight] = useState(null);
    const [embedWidth, setEmbedWidth] = useState(null);

    const [quizData, setQuizData] = useState({
        "type": "pers-quiz",
        "color": "",
        "title": "",
        "description": "",
        "imageUrl": "",
        "data": {
            "scores": {
                "1": {
                    "title": "",
                    "description": "",
                    "imageUrl": ""
                },
            },
            "questions": {

            }
        }
    });

    return (
        <div className={"container"}>
            <Typography level={"h1"}>Create Quiz</Typography>
            <div className={"dashboard"} style={{ display: 'flex', flexDirection: 'row', gap: '20px',  }}>
                <div style={{ width: '60%' }}>
                    <AccordionGroup
                        transition="0.2s"
                    >
                        <Accordion>
                            <AccordionSummary>Setup</AccordionSummary>
                            <AccordionDetails>
                                <FormControl>
                                    <FormLabel>Title</FormLabel>
                                    <Input
                                        value={quizData.title}
                                        onChange={(e) => setQuizData({
                                            ...quizData,
                                            title: e.target.value
                                        })}
                                    />
                                    <FormLabel>Description</FormLabel>
                                    <Input
                                        value={quizData.description}
                                        onChange={(e) => setQuizData({
                                            ...quizData,
                                            description: e.target.value
                                        })}
                                    />
                                    <FormLabel>Image URL</FormLabel>
                                    <Input
                                        value={quizData.imageUrl}
                                        onChange={(e) => setQuizData({
                                            ...quizData,
                                            imageUrl: e.target.value
                                        })}
                                    />
                                    <FormLabel>Theme Color Code (HEX)</FormLabel>
                                    <Input
                                        value={quizData.color}
                                        onChange={(e) => {
                                            const input = e.target.value.replace(/#/g, ''); // Remove all '#' characters
                                            setQuizData({
                                                ...quizData,
                                                color: input
                                            });
                                        }}
                                        startDecorator={"#"}
                                        endDecorator={
                                            <Box
                                                sx={{
                                                    backgroundColor: `#${quizData.color || '000'}`,
                                                    width: '20px',     // Set the fixed width you want
                                                    height: '20px',     // Set height to match the Chip size or your design
                                                    borderRadius: '10px',  // Similar rounded corners as Chip
                                                }}
                                            />
                                        }
                                    />
                                </FormControl>
                            </AccordionDetails>
                        </Accordion>
                        <Accordion>
                            <AccordionSummary>Score Outcomes</AccordionSummary>
                            <AccordionDetails>
                                <AccordionGroup
                                    variant="outlined"
                                    transition="0.2s"
                                    sx={(theme) => ({
                                        maxWidth: 400,
                                        borderRadius: theme.radius.lg,
                                        overflow: 'hidden',
                                    })}
                                >
                                    {Object.entries(quizData.data.scores).map(([key, item]) => (
                                        <Accordion>
                                            <AccordionSummary>{item.title}</AccordionSummary>
                                            <AccordionDetails>
                                                <FormControl>
                                                    <FormLabel>Title</FormLabel>
                                                    <Input
                                                        value={item.title}
                                                        onChange={(e) => setQuizData({
                                                            ...quizData,
                                                            data: {
                                                                ...quizData.data,
                                                                scores: {
                                                                    ...quizData.data.scores,
                                                                    [key]: {
                                                                        ...quizData.data.scores[key],
                                                                        title: e.target.value
                                                                    }
                                                                }
                                                            }
                                                        })}
                                                    />
                                                    <FormLabel>Description</FormLabel>
                                                    <Input
                                                        value={item.description}
                                                        onChange={(e) => setQuizData({
                                                            ...quizData,
                                                            data: {
                                                                ...quizData.data,
                                                                scores: {
                                                                    ...quizData.data.scores,
                                                                    [key]: {
                                                                        ...quizData.data.scores[key],
                                                                        description: e.target.value
                                                                    }
                                                                }
                                                            }
                                                        })}
                                                    />
                                                    <FormLabel>Image URL</FormLabel>
                                                    <Input
                                                        value={item.imageUrl}
                                                        onChange={(e) => setQuizData({
                                                            ...quizData,
                                                            data: {
                                                                ...quizData.data,
                                                                scores: {
                                                                    ...quizData.data.scores,
                                                                    [key]: {
                                                                        ...quizData.data.scores[key],
                                                                        imageUrl: e.target.value
                                                                    }
                                                                }
                                                            }
                                                        })}
                                                    />
                                                    <FormLabel>Minimum Correct Answers</FormLabel>
                                                    <Input
                                                        value={item.score}
                                                        onChange={(e) => setQuizData({
                                                            ...quizData,
                                                            data: {
                                                                ...quizData.data,
                                                                scores: {
                                                                    ...quizData.data.scores,
                                                                    [key]: {
                                                                        ...quizData.data.scores[key],
                                                                        score: e.target.value
                                                                    }
                                                                }
                                                            }
                                                        })}
                                                    />
                                                </FormControl>
                                            </AccordionDetails>
                                        </Accordion>
                                    ))}
                                </AccordionGroup>
                                <Button
                                    startDecorator={<AddIcon/>}
                                    onClick={() => {
                                        const newKey = Object.keys(quizData.data.scores).length + 1;
                                        setQuizData({
                                            ...quizData,
                                            data: {
                                                ...quizData.data,
                                                scores: {
                                                    ...quizData.data.scores,
                                                    [newKey]: {
                                                        title: "",
                                                        description: "",
                                                        imageUrl: ""
                                                    }
                                                }
                                            }
                                        });
                                    }}
                                >Add Score Outcome</Button>
                            </AccordionDetails>
                        </Accordion>
                        <Accordion>
                            <AccordionSummary>Questions</AccordionSummary>
                            <AccordionDetails>
                                <AccordionGroup
                                    variant="outlined"
                                    transition="0.2s"
                                    sx={(theme) => ({
                                        maxWidth: 400,
                                        borderRadius: theme.radius.lg,
                                        overflow: 'hidden',
                                    })}
                                >
                                    {Object.entries(quizData.data.questions).map(([key, item]) => (
                                        <Accordion>
                                            <AccordionSummary>{item.question}</AccordionSummary>
                                            <AccordionDetails>
                                                <FormControl>
                                                    <FormLabel>Question</FormLabel>
                                                    <Input
                                                        value={item.question}
                                                        onChange={(e) => setQuizData({
                                                            ...quizData,
                                                            data: {
                                                                ...quizData.data,
                                                                questions: {
                                                                    ...quizData.data.questions,
                                                                    [key]: {
                                                                        ...quizData.data.questions[key],
                                                                        question: e.target.value
                                                                    }
                                                                }
                                                            }
                                                        })}
                                                    />
                                                    <FormLabel>Description</FormLabel>
                                                    <Input
                                                        value={item.description}
                                                        onChange={(e) => setQuizData({
                                                            ...quizData,
                                                            data: {
                                                                ...quizData.data,
                                                                questions: {
                                                                    ...quizData.data.questions,
                                                                    [key]: {
                                                                        ...quizData.data.questions[key],
                                                                        description: e.target.value
                                                                    }
                                                                }
                                                            }
                                                        })}
                                                    />
                                                    <FormLabel>Image URL</FormLabel>
                                                    <Input
                                                        value={item.imageUrl}
                                                        onChange={(e) => setQuizData({
                                                            ...quizData,
                                                            data: {
                                                                ...quizData.data,
                                                                questions: {
                                                                    ...quizData.data.questions,
                                                                    [key]: {
                                                                        ...quizData.data.questions[key],
                                                                        imageUrl: e.target.value
                                                                    }
                                                                }
                                                            }
                                                        })}
                                                    />
                                                    <FormLabel>Justification</FormLabel>
                                                    <Input
                                                        value={item.justification}
                                                        onChange={(e) => setQuizData({
                                                            ...quizData,
                                                            data: {
                                                                ...quizData.data,
                                                                questions: {
                                                                    ...quizData.data.questions,
                                                                    [key]: {
                                                                        ...quizData.data.questions[key],
                                                                        justification: e.target.value
                                                                    }
                                                                }
                                                            }
                                                        })}
                                                    />
                                                    <FormLabel>Answers</FormLabel>
                                                    {Object.entries(item.answers).map(([answerKey, answerValue]) => (
                                                        <div key={answerKey} style={{ display: 'flex', flexDirection: 'column', marginBottom: 16 }}>
                                                            <FormLabel>Answer {answerKey}</FormLabel>
                                                            <Input
                                                                value={answerValue.text}
                                                                onChange={(e) => setQuizData({
                                                                    ...quizData,
                                                                    data: {
                                                                        ...quizData.data,
                                                                        questions: {
                                                                            ...quizData.data.questions,
                                                                            [key]: {
                                                                                ...quizData.data.questions[key],
                                                                                answers: {
                                                                                    ...quizData.data.questions[key].answers,
                                                                                    [answerKey]: {
                                                                                        ...quizData.data.questions[key].answers[answerKey],
                                                                                        text: e.target.value
                                                                                    }
                                                                                }
                                                                            }
                                                                        }
                                                                    }
                                                                })}
                                                            />
                                                            <label style={{ display: 'flex', alignItems: 'center', marginTop: 4 }}>
                                                                <input
                                                                    type="checkbox"
                                                                    checked={
                                                                        Array.isArray(item.correct) && item.correct.includes(answerKey)
                                                                    }
                                                                    onChange={(e) => {
                                                                        const currentCorrect = Array.isArray(item.correct) ? item.correct : [];
                                                                        const updatedCorrect = e.target.checked
                                                                            ? [...new Set([...currentCorrect, answerKey])]
                                                                            : currentCorrect.filter((c) => c !== answerKey);

                                                                        setQuizData({
                                                                            ...quizData,
                                                                            data: {
                                                                                ...quizData.data,
                                                                                questions: {
                                                                                    ...quizData.data.questions,
                                                                                    [key]: {
                                                                                        ...quizData.data.questions[key],
                                                                                        correct: updatedCorrect
                                                                                    }
                                                                                }
                                                                            }
                                                                        });
                                                                    }}
                                                                    style={{ marginRight: 8 }}
                                                                />
                                                                Correct Answer
                                                            </label>
                                                        </div>
                                                    ))}
                                                    <Button
                                                        startDecorator={<AddIcon/>}
                                                        onClick={() => {
                                                            const newAnswerKey = Object.keys(item.answers).length + 1;
                                                            setQuizData({
                                                                ...quizData,
                                                                data: {
                                                                    ...quizData.data,
                                                                    questions: {
                                                                        ...quizData.data.questions,
                                                                        [key]: {
                                                                            ...quizData.data.questions[key],
                                                                            answers: {
                                                                                ...item.answers,
                                                                                [newAnswerKey]: {
                                                                                    text: ""
                                                                                }
                                                                            }
                                                                        }
                                                                    }
                                                                }
                                                            });
                                                        }}
                                                    >Add Answer</Button>
                                                </FormControl>
                                            </AccordionDetails>
                                        </Accordion>
                                    ))}
                                </AccordionGroup>
                                <Button
                                    startDecorator={<AddIcon/>}
                                    onClick={() => {
                                        const newKey = Object.keys(quizData.data.questions).length + 1;
                                        setQuizData({
                                            ...quizData,
                                            data: {
                                                ...quizData.data,
                                                questions: {
                                                    ...quizData.data.questions,
                                                    [newKey]: {
                                                        question: "",
                                                        description: "",
                                                        imageUrl: "",
                                                        answers: {}
                                                    }
                                                }
                                            }
                                        });
                                    }}
                                >Add Question</Button>
                            </AccordionDetails>
                        </Accordion>
                        <Accordion>
                            <AccordionSummary>Export JSON</AccordionSummary>
                            <AccordionDetails>
                                <Button
                                    onClick={() => {
                                        const jsonString = JSON.stringify(quizData, null, 2); // Convert quizData to JSON string
                                        const blob = new Blob([jsonString], { type: 'application/json' }); // Create a Blob
                                        const url = URL.createObjectURL(blob); // Create a URL for the Blob
                                        const link = document.createElement('a'); // Create a temporary anchor element
                                        link.href = url;
                                        link.download = 'quizData.json'; // Set the file name
                                        link.click(); // Trigger the download
                                        URL.revokeObjectURL(url); // Clean up the URL object
                                    }}
                                >
                                    Download Quiz Data
                                </Button>
                            </AccordionDetails>
                        </Accordion>
                        <Accordion>
                            <AccordionSummary>Upload JSON</AccordionSummary>
                            <AccordionDetails>
                                <Typography level={"body-md"}>
                                    Upload the downloaded JSON file to a online CDN (Content Delivery Network). The file just needs to be 1. Accessible online at a static URL and 2. Not require any authentication to access it. (Optional 3. not blocked by a workplace/school firewall)

                                    There are dozens of free and paid services that can do this including: <Link href={"https://cloudinary.com"} target="_blank" rel="noopener noreferrer">Cloudinary</Link>, <Link href={"https://wordpress.com/support/uploading-documents/"} target="_blank" rel="noopener noreferrer">Wordpress</Link>, <Link href={"https://help.dropbox.com/share/force-download"} target="_blank" rel="noopener noreferrer">Dropbox</Link>, and many others!
                                </Typography>
                                <br/>
                                <FormControl>
                                    <FormLabel>JSON URL</FormLabel>
                                    <Input
                                        value={dataUrl}
                                        onChange={(e) => setDataUrl(e.target.value)}
                                    />
                                </FormControl>
                            </AccordionDetails>
                        </Accordion>
                        <Accordion>
                            <AccordionSummary>Generate Embed</AccordionSummary>
                            <AccordionDetails>
                                <FormControl>
                                    <FormLabel>Height</FormLabel>
                                    <Input
                                        value={embedHeight}
                                        onChange={(e) => setEmbedHeight(e.target.value)}
                                    />
                                    <FormLabel>Width</FormLabel>
                                    <Input
                                        value={embedWidth}
                                        onChange={(e) => setEmbedWidth(e.target.value)}
                                    />
                                </FormControl>
                            </AccordionDetails>
                        </Accordion>
                        <Accordion>
                            <AccordionSummary>Publish</AccordionSummary>
                            <AccordionDetails>
                                <FormControl>
                                    <FormLabel>Embed Code</FormLabel>
                                    <Textarea
                                        value={`<iframe src="https://online-interactives.vercel.app/published/quiz/${encodeURIComponent(dataUrl)}"${embedWidth !== null ? ` width="${embedWidth}"` : ""}${embedHeight !== null ? ` height="${embedHeight}"` : ""}></iframe>`}
                                        readOnly
                                    />
                                </FormControl>
                            </AccordionDetails>
                        </Accordion>
                    </AccordionGroup>

                </div>
                <div style={{ width: '40%' }}>
                    <iframe title={"preview"} src={`https://online-interactives.vercel.app/published/quiz/${encodeURIComponent(dataUrl)}`} width={embedWidth !== null ? (embedWidth) : ("100%")} height={embedHeight !== null ? (embedHeight) : ("100%")}></iframe>
                </div>
            </div>
        </div>
    );
};

export default PersQuizGen;